import { makeStyles, tokens } from '@fluentui/react-components';
import { isMobile } from 'react-device-detect';

const useHeroMediaLayoutStyles = makeStyles({
  container: {
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
    gap: tokens.spacingVerticalL,
  },
  sideContainer: {
    display: 'flex',
    gap: tokens.spacingHorizontalL,
    alignItems: 'stretch',
    height: '100%',
  },
  leftSideContent: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    flex: '0 0 53.5%',
    maxHeight: isMobile ? '70%' : undefined,
  },
  rightSideContent: {
    overflow: 'hidden',
  },
  mobileSideContainer: {
    flexDirection: 'column-reverse',
    gap: tokens.spacingHorizontalM,
    alignItems: 'stretch',
  },
  fullSizeContainer: {
    position: 'relative',
    width: '100%',
    height: '100%',
    overflow: 'hidden',
  },
  mediaBackground: {
    'position': 'absolute',
    'top': 0,
    'left': 0,
    'width': '100%',
    'height': '100%',
    'zIndex': 0,
    '& img, & video': {
      width: '100%',
      height: '100%',
      objectFit: 'cover',
    },
  },
  overlayContent: {
    position: 'absolute',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    textAlign: 'center',
    zIndex: 1,
  },
  footer: {
    textAlign: 'left',
  },
});

export default useHeroMediaLayoutStyles;
